import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ColorHelper {


 

  convertSrmToWebColor(color: number) {
    let srm = Math.round(color);

    srm = srm < 1 ? 1 : srm > 40 ? 40 : srm;

    switch (srm) {
      case 1: return '#FFE699';
      case 2: return '#FFD878';
      case 3: return '#FFCA5A';
      case 4: return '#FFBF42';
      case 5: return '#FBB123';
      case 6: return '#F8A600';
      case 7: return '#F39C00';
      case 8: return '#EA8F00';
      case 9: return '#E58500';
      case 10: return '#DE7C00';
      case 11: return '#D77200';
      case 12: return '#CF6900';
      case 13: return '#CB6200';
      case 14: return '#C35900';
      case 15: return '#BB5100';
      case 16: return '#B54C00';
      case 17: return '#B04500';
      case 18: return '#A63E00';
      case 19: return '#A13700';
      case 20: return '#9B3200';
      case 21: return '#952D00';
      case 22: return '#8E2900';
      case 23: return '#882300';
      case 24: return '#821E00';
      case 25: return '#7B1A00';
      case 26: return '#771900';
      case 27: return '#701400';
      case 28: return '#6A0E00';
      case 29: return '#660D00';
      case 30: return '#5E0B00';
      case 31: return '#5A0A02';
      case 32: return '#600903';
      case 33: return '#520907';
      case 34: return '#4C0505';
      case 35: return '#470606';
      case 36: return '#440607';
      case 37: return '#3F0708';
      case 38: return '#3B0607';
      case 39: return '#3A070B';
      case 40: return '#36080A';
      default:
        return '#BF7138';
    }

  }
}